import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit,
  OnDestroy, NgZone, Output, EventEmitter, DoCheck, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validator, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { FacebookService, LoginResponse, LoginOptions, UIResponse,
  UIParams, FBVideoComponent } from 'ngx-facebook';
import { UserService } from "../../service/user.service";
import {eventEmitterService} from "../../service/eventEmitter.service";
import { Subject, combineLatest } from 'rxjs';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.css']
})
export class InviteComponent implements OnInit , AfterViewInit, OnDestroy, OnChanges {

  fbookFriends = [];
  invite: FormGroup;
  emailError = false;
  emailFormatError = false;
  successMsg = '';
  userList = [];
  totalResidents = 1;

  apiUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;

  // Fetch local storage items
  id = localStorage.getItem('residents');
  isManager = localStorage.getItem('isManager');
  buildingId = localStorage.getItem('userBuildingId');
  ismaintenance = localStorage.getItem('maintenance');
  userType = localStorage.getItem('type');

  buildindResidentsMap: Map<number, any[]> = new Map();

  userListSetEvent: Subject<any> = new Subject<any>();
  buildingChangedEvent: Subject<boolean> = new Subject<boolean>();

  @Input() buildingToSendInvite:any;

  constructor(private fbook: FacebookService,
              private fb: FormBuilder,
              private userService : UserService,
              private chatService: eventEmitterService) {

    fbook.init(environment.facebook);
  }

  ngOnInit() {
    this.subscribeToUserListChangeEvents();
     if(this.isManager === 'true'){
      this.userService.getAllUsersByBuildingIds(this.buildingId).subscribe(
        (users) => {
          console.log('All users in the building : ', users);
          for (const building of users.buildings) {
            const temp = [];
            for (const resident of building.resident) {
              this.userList.push(resident);
              temp.push(resident);
            }
            this.buildindResidentsMap.set(building.id, temp);
          }

          this.userList = this.userList.filter((v, i, a) => i === a.findIndex((t) => (
            t.id === v.id )));
          console.log('user LIst : ', this.userList);
          this.totalResidents = this.userList.length;
          // console.log('userListSetEvent');
          this.userListSetEvent.next(true);
        }
      );
    }else {
      this.userService.getAllUsersByBuildingId(this.buildingId).subscribe(
        (users) => {
          console.log('All user in current building : ', users);
          if (this.userType != 'admin') {
          users.buildings.resident.forEach(resident => {
            if (resident.id != this.id ) {
              resident.lastName =  resident.lastName.substring(0, 1);
            }
          });
        }
          this.userList = users.buildings.resident;
          this.totalResidents = this.userList.length;
        }
      );
    }

    this.invite = this.fb.group({
      email: ['', Validators.compose([Validators.required])],
    });
  }

  private subscribeToUserListChangeEvents() {
    combineLatest([this.userListSetEvent.asObservable(), this.buildingChangedEvent.asObservable()]).subscribe(() => {
      // console.log('combineLatest');
      if (this.buildingToSendInvite && this.buildingToSendInvite.id && this.userList.length > 0) {
        this.userList = this.buildindResidentsMap.get(this.buildingToSendInvite.id);
        this.userList = this.userList.filter((v, i, a) => i === a.findIndex((t) => (
          t.id === v.id)));
        // console.log('user LIst : ', this.userList);
        this.totalResidents = this.userList.length;
      }
    });
  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    const { buildingToSendInvite} = changes;
    if (buildingToSendInvite.currentValue) {
      if (this.isManager === 'true') {
        // console.log('buildingChangedEvent');
        this.buildingChangedEvent.next(true);
      }
    }
  }

  inviteFacebookFriends(){

  }

  /**
   * Get the users friends
   */
  getUserFriends() {

    this.fbook.api('/me/friends?limit=5000&fields=email,name')
      .then((res: any) => {
        console.log("Find Friends", res);
        this.getFriendsDetails(res);
      })
      .catch();
  }

  /**
   * Get the users friends
   */
  getFriendsDetails(users) {
    users.data.forEach(friend => {
      this.fbook.api('/'+friend.id+'?fields=id,name,first_name,email,gender,picture.width(150).height(150),age_range,friends')
        .then((res: any) => {
          this.fbookFriends.push(res);
        })
        .catch();
    });

    if(this.fbookFriends){
      $('#invite_friends_modal').show();
    }
    console.log("Facebook Friends");

    console.log(this.fbookFriends);

  }


  /**
   * Login with minimal permissions. This allows you to see their public profile only.
   */
  getFriends() {
    const loginOptions: LoginOptions = {
      enable_profile_selector: true,
      return_scopes: true,
      scope: 'public_profile,user_friends,email,pages_show_list'
    };


    this.fbook.login(loginOptions)
      .then((res: LoginResponse) => {
        console.log('Logged in', res);
        //accessToken
        //userID
        if(res){
          //this.getUserFriends();
          this.sharePost();
        }

      })
      .catch();
  }

  sharePost(){
    let params: UIParams = {
        method: 'send',
        name: 'This is the content of the "name" field.',
        link: environment.apiUrl + 'feed',
        description: 'This is the content of the "description" field, below the caption.',
    };

    this.fbook.ui(params)
      .then((res: UIResponse) => console.log(res))
      .catch((e: any) => console.error(e));
  }

  clearErrors(inviteForm){
         this.emailError = false;
         this.emailFormatError = false;
  }

  inviteModalManipulation(){
    this.chatService.eventEmit$.next({feedShareOnMail: false});
  }

  sendEmailInvite(inviteForm){

    var valid = true;
    this.emailError = false;
    this.emailFormatError = false;

    // var inviteEmailsList = $.trim($(inviteForm).find("#sendEmailInvites").val());
    const val = $(inviteForm).find("#sendEmailInvites").val();
    const inviteEmailsList = $.trim(String(val));

    if(inviteEmailsList == ''){
      valid = false;
      this.emailError = true;
      $(inviteForm).find("#sendEmailInvites").val('').focus();
    }

    if(valid){

          var inviteEmails = inviteEmailsList.split(',');
          var length = inviteEmails.length;

          var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

          var emailValid = true;
          for(var i=0; i<length; i++){
            if(!inviteEmails[i].match(emailReg)){
                emailValid = false;
            }
          }

          if(emailValid === true){

               this.userService.sendEmailInvite(inviteEmails, null, this.buildingToSendInvite).subscribe((res)=>{
                    if(res){
                        if(res.success==true){
                             this.successMsg = res.message;

                             setTimeout(()=>{
                                  this.successMsg = '';
                                  inviteForm.reset();
                             },3000);
                        }
                    }
               });

          }else{
              this.emailFormatError = true;

          }

    }

  }

  openChat(user){
    this.chatService.open(user);
  }

}
